<template>
  <div class="w-100">
    <Loader class="w-100" :loading="loading">
      <div class=" p-list-representation-wrapper align-items-start">
        <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
          <div class="w-100" >
            <appHeader></appHeader>
          </div>

          <div class=" row p-list-representation-data w-100" :key="updateData">
            <contentList
            @submitData="submitData"

            :all-types="allTypes"
            :all-cups="allCups"
            :page="page"
            :form-data="formData"
            :selected-type="selectedType"
            :selected-cup="selectedCup"
            ></contentList>
          </div>

        </div>

      </div>

    </Loader>
  </div>
</template>

<script>
import contentList from '../components/entryAndEditListTabScorersAndKnockoutAndGroup/contentList';
import appHeader from '../components/includes/AppHeader';
import addCama from '../modules/addCama.js'
import settings from '../modules/settings';



export default {
  name: "entryAndEditListTabScorersAndKnockoutAndGroup",
  components: {
    contentList,
    appHeader,
  },

  props: {

  },

  data() {
    return {
      loading                                 : false,
      updateCitySelected                      : 0,
      page                                    : 0,
      checkEmptyCity                     : 'default',
      formData   : {
        url             : '',
        title           : '',
        cup_id          : '',
        type            : '',
        id              : '',
      },
      tableData                               : [],
      page                                    : 1,
      statusGetCupAndGetPlayer : false,
      updateData               : 0,
      singleGameTabData        : {},
      allCups                  : [],
      allTypes                 : [
        {
          id    : 1,
          title : 'جدول گروهی',
          value : 'group_stage_table',
        },
        {
          id    : 2,
          title : 'جدول حذفی',
          value : 'knockout_stage_table',
        },
        {
          id    : 3,
          title : 'جدول امتیاز افراد',
          value : 'scorers_table',
        },
      ],
      selectedType             : {},
      selectedCup              :  {},


    }
  },

  watch: {
    singleGameTabData(data){
      this.formData = data;
      // this.getAllCups();
      this.getAndSetDefaultData();
      this.updateData++;
    },

  },

  created() {
  },


  mounted() {
    const getParams = this.$route.params.id;

    if (typeof(getParams) != 'undefined') {
      this.formData.id   = getParams;
    }
    else {
      delete this.formData.id;
    }

    const  singleGameTabData = JSON.parse(localStorage.getItem('singleGameTabData'));
    this.singleGameTabData   = singleGameTabData;

  },


  methods: {
    submitData(data){
      this.loading      = true;
      this.$store
      .dispatch('entryAndEditListTabScorersAndKnockoutAndGroup/entryAndEdit', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
        this.loading      = false;
        if (res.is_successful) {
          localStorage.setItem('singleGameTabData', JSON.stringify(res.data));
          this.$router.push({name:'tabScorersAndKnockoutAndGroup' ,params:{cup_id : res.data.cup_id , state_active_tab : res.data.type} } )
        }
      })
    },

    getAndSetDefaultData(){
      const logicFindSelectedType = () => {
        const findType          = this.formData.type;
        let selectedDefaultType = {};

        this.allTypes.map((t)=>{
          if (t.value == findType) {
            selectedDefaultType  = t;
          }
        })

        this.selectedType =  selectedDefaultType;
      }

      const logicFindCupSelectedDefault = () => {
        const valueDefaultCup   = this.formData.cup_id;
        let findSelectedCup     = {};

        this.allCups.map((t)=>{
          if (t.id == valueDefaultCup) {
            findSelectedCup  = t;
          }
        })

        this.selectedCup =  findSelectedCup;
      }



      logicFindSelectedType();
      logicFindCupSelectedDefault();
    },

    // getAllCups(){
    //   this.$store
    //   .dispatch('entryAndEditListTabScorersAndKnockoutAndGroup/getAllCups', {
    //
    //   })
    //   .then((res)=>{
    //     this.allCups = res.data;
    //     this.loading = false;
    //     this.getAndSetDefaultData();
    //   })
    // },





  }


}
</script>
